export { Timer } from "./Timer";
export { TimerManager } from "./TimerManager";



// WEBPACK FOOTER //
// ./src/index.ts